import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

/**
 * Gere les notifications push cote application (Capacitor + FCM).
 *
 * Au demarrage, pour un utilisateur connecte sur mobile : demande la
 * permission, enregistre l'appareil aupres du backend, et route l'utilisateur
 * vers l'ecran concerne quand il tape une notification.
 *
 * Aucun effet sur le web (Capacitor.isNativePlatform() renvoie false).
 */
const PushManager = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform() || !user) return;

    const handles: any[] = [];

    const setup = async () => {
      try {
        let perm = await PushNotifications.checkPermissions();
        if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') {
          perm = await PushNotifications.requestPermissions();
        }
        if (perm.receive !== 'granted') return;

        await PushNotifications.register();

        // Jeton d'appareil recu de FCM -> on l'enregistre cote backend.
        handles.push(await PushNotifications.addListener('registration', async (token) => {
          try {
            await api.post('/users/devices/register/', {
              token: token.value,
              platform: Capacitor.getPlatform(),
            });
          } catch {
            /* enregistrement best-effort */
          }
        }));

        // Tap sur une notification -> navigation vers l'ecran concerne.
        handles.push(await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
          const data: any = action.notification?.data || {};
          if (data.type === 'message') {
            navigate('/messages');
          } else if (data.type === 'booking' || data.type === 'booking_confirmed') {
            navigate(user.role === 'COACH' ? '/coach/dashboard' : '/sportif/dashboard');
          }
        }));
      } catch {
        /* push indisponible : on ignore silencieusement */
      }
    };

    setup();
    return () => { handles.forEach((h) => h?.remove?.()); };
  }, [user, navigate]);

  return null;
};

export default PushManager;
